import { Checkbox } from '@progress/kendo-react-inputs'
import RangeDatePickerHL from '../rangePickerHL/rangeDatePickerHL.pure'
import RangeTimePickerHL from '../rangePickerHL/rangeTimePickerHL.pure'

// Mismos colores que las gráficas de sentimiento (SentimentDailyGraph / usage.view.js):
// verde = positivo, amarillo = neutral, rojo = negativo, gris = sin clasificar.
const SENTIMENT_COLOR = { positive: '#69B75C', neutral: '#FACC15', negative: '#EF4444', unclassified: '#9CA3AF' }
const SENTIMENT_IDS = ['positive', 'negative', 'neutral', 'unclassified']

const AdvancedSearchFilters = ({ t, filterDraft, handleFilterChange, handleToggleSentiment, applyFilters, clearFilters }) => {
  return (
    <div className="advanced-search-panel">
      <div className="advanced-search-row">
        <div className="advanced-search-field">
          <label>{t('dateRange')}</label>
          <RangeDatePickerHL
            value={{ start: filterDraft.dateStart, end: filterDraft.dateEnd }}
            placeholder={t('dateRangePlaceholder')}
            onChange={(range) => {
              handleFilterChange('dateStart', range.start)
              handleFilterChange('dateEnd', range.end)
            }}
          />
        </div>
        <div className="advanced-search-field">
          <label>{t('timeRange')}</label>
          <RangeTimePickerHL
            value={{ start: filterDraft.timeStart, end: filterDraft.timeEnd }}
            placeholder={t('timeRangePlaceholder')}
            labelStart={t('timeStart')}
            labelEnd={t('timeEnd')}
            onChange={(range) => {
              handleFilterChange('timeStart', range.start)
              handleFilterChange('timeEnd', range.end)
            }}
          />
        </div>
        <div className="advanced-search-field advanced-search-sentiments">
          <label>{t('sentimentFilterTitle')}</label>
          <div className="advanced-search-sentiments-list">
            {SENTIMENT_IDS.map(id => (
              <label key={id} className="advanced-search-sentiment-item">
                <Checkbox
                  checked={filterDraft.sentiments.includes(id)}
                  onChange={() => handleToggleSentiment(id)}
                />
                <span className="advanced-search-sentiment-dot" style={{ backgroundColor: SENTIMENT_COLOR[id] }} />
                <span>{t(`sentiment.${id}`)}</span>
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="advanced-search-actions">
        <button className="advanced-search-apply" onClick={applyFilters}>{t('applyFilters')}</button>
        <button className="advanced-search-clear" onClick={clearFilters}>{t('clearFilters')}</button>
      </div>
    </div>
  )
}

export default AdvancedSearchFilters
